function trackWebVitalMetrics() {
    if (!('performance' in window && 'PerformanceObserver' in window)) {
        console.warn('Performance API o PerformanceObserver non disponibili.');
        return;
    }

    // Helper per creare i gruppi e formattare i log
    const logMetric = (groupName, metrics) => {
        console.groupCollapsed(`[Shopify Performance] ${groupName}`);
        for (const [key, value] of Object.entries(metrics)) {
            console.log(`${key}: %c${value}`, 'color: #008060; font-weight: bold;');
        }
        console.groupEnd();
    };

    // Helper per l'osservazione dei Web Vitals
    const observePerformanceEntry = (entryType, callback) => {
        try {
            const observer = new PerformanceObserver((list) => {
                list.getEntries().forEach(callback);
            });
            // Fix: 'type' accetta una stringa
            observer.observe({ type: entryType, buffered: true });
            return observer;
        } catch (e) {
            console.warn(`Tipo di performance non supportato: '${entryType}'.`);
            return null;
        }
    };

    // 1. Largest Contentful Paint (LCP)
    observePerformanceEntry('largest-contentful-paint', (entry) => {
        logMetric('Largest Contentful Paint (LCP)', {
            'Valore': `${Math.round(entry.startTime)} ms`,
            'Elemento': entry.element || 'N/D',
            'URL Risorsa': entry.url || 'N/D'
        });
    });

    // 2. First Contentful Paint (FCP)
    observePerformanceEntry('paint', (entry) => {
        if (entry.name === 'first-contentful-paint') {
            logMetric('First Contentful Paint (FCP)', {
                'Valore': `${Math.round(entry.startTime)} ms`
            });
        }
    });

    // 3. Navigation Timing (TTFB e Page Load)
    const processNavigationTiming = () => {
        const navEntry = performance.getEntriesByType('navigation')[0];
        if (!navEntry) return;

        const metrics = {
            'Time to First Byte (TTFB)': `${Math.round(navEntry.responseStart)} ms`
        };

        if (navEntry.loadEventEnd > 0) {
            metrics['Caricamento Completo (loadEventEnd)'] = `${Math.round(navEntry.loadEventEnd)} ms`;
            metrics['Tempo di DOM Interactive'] = `${Math.round(navEntry.domInteractive)} ms`;
        }

        logMetric('Metriche di Navigazione', metrics);
    };

    // Gestione del ciclo di vita su Shopify
    if (document.readyState === 'complete') {
        processNavigationTiming();
    } else {
        window.addEventListener('load', processNavigationTiming);
    }
}

// Inizializzazione per Shopify (compatibile con l'editor di temi)
if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', trackWebVitalMetrics);
} else {
    trackWebVitalMetrics();
}